import { render, staticRenderFns } from "./vs-inv-dropdown.vue?vue&type=template&id=70a8efe4&"
import script from "./vs-inv-dropdown.vue?vue&type=script&lang=js&"
export * from "./vs-inv-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports